import { Injectable } from '@angular/core';
import { tap } from 'rxjs';
import { CertificationWizard } from '../models/certification-wizard.model';
import { AppHttpClient } from './app-http-client.service';
import { UtilService } from './util.service';
import { UserService } from './user.service';
import { AnswerModel } from '../models/answer-model';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class CertWizService {

  certWizard: CertificationWizard = new CertificationWizard();
  constructor(
    public http : AppHttpClient,
    public userService : UserService,
    public util : UtilService,
    public router: Router
  ) { }

  init(){
    return this.http.get('cert-wiz',this.userService.getRoleQueryString()).pipe(
      tap((res:any)=>{
        res = this.checkCertWizardResponce(res);
        this.certWizard = new CertificationWizard(res);
      })
    );
  }

  checkCertWizardResponce(res:any) {
    if(res.questions.length){
      let question = res.questions[res.questions.length-1];
      question.selectedAnswers = question.selectedAnswers || [];
      if(!question.selectedAnswers.length){
        if(question.answerType.name == 'text'){
          question.selectedAnswers.push(new AnswerModel(question.answers[0]));
        }
      }
    }
    return res;
  }

  next(){
    return this.http.post('cert-wiz', this.certWizard.toJSON()).pipe(
      tap((res:any)=>{
        if(res.requiredArtifacts){
          res.requiredArtifacts = this.util.sortArtifacts(res.requiredArtifacts);
        }
        res = this.checkCertWizardResponce(res);
        this.certWizard = new CertificationWizard(res);
      })
    );
  }

  back(){
    return this.http.post('cert-wiz/back', this.certWizard.toJSON()).pipe(
      tap((res:any)=>{
        res = this.checkCertWizardResponce(res);
        this.certWizard = new CertificationWizard(res);
      })
    );
  }

  certWizardRedirect() {
    if(this.userService.isTeams()){
      this.router.navigate(['/app/cert-wizard']);
      return;
    }
    let title = "Please note the following that applies to all new applications:";
    let msgString = `An application is not considered complete and will not assign to a certification specialist for review until all supplemental documents have been received. Before contacting the certification office, please allow four to six weeks for the application to be reviewed as this delays the process.`;

    this.util.openMsgDialog(msgString, title, false)
    .afterClosed().subscribe((result) => { 
      if(result){
        this.router.navigate(['/app/cert-wizard']);
      }
    });

    
  }

}
